import { MAX_GUEST_LINK_EMAILS_BATCH, } from '@lucidlink/dto/validation';
import { translate } from '@lucidlink/uicore';
export const guestLinkEmailValidationRules = () => [
    {
        errorCodes: ['guestLink.emails.maxLength'],
        label: translate('Add up to {{MAX_GUEST_LINK_EMAILS_BATCH}} guests at a time.', { MAX_GUEST_LINK_EMAILS_BATCH }),
    },
    {
        errorCodes: ['guestLink.email.format', 'guestLink.email.required'],
        label: translate('Provide valid email addresses.'),
    },
];
